import { DeepPartial } from "@towersystems/roam-common/lib/shared-types";
import { PosApiResponse } from "./pos-api-response";

export abstract class PosApiResponseWithResult extends PosApiResponse {
  constructor(input?: DeepPartial<PosApiResponseWithResult>) {
    super(input);
    if (this.ResponseText == null) {
      this.ResponseText = "";
    }
  }

  // Indicates if the request was successful
  public Success: boolean;

  // The response code of the request. Will vary depending on the type of request. In most cases you can
  // ignore this value and use <see cref="Success" /> in your business logic.
  public ResponseCode: string;

  // The response text for the response code. Will vary depending on the type of request. For some
  // responses it may be appropriate to display this directly to the POS user.
  public ResponseText: string;
}
